module.exports = __webpack_public_path__ + "static/media/call-icon.fcf7ba85.png";